import React, { Component } from "react";
import PropTypes from "prop-types";
import { Icon, Menu, Popup, Visibility, Dropdown } from "semantic-ui-react";

import { Link } from "react-router-dom";
import { isMobile, isTabletOrLess } from "utils/isMobile";

const headerStyle = {
	backgroundColor: "#00c7b1",
};

class DesktopContainer extends Component {
	state = {
		active: null,
	};

	hideFixedMenu = () => this.setState({ fixed: false });
	showFixedMenu = () => this.setState({ fixed: true });

	render() {
		const { children, pathname, generalParameters, user } = this.props;
		return (
			<div style={{ height: "100%" }}>
				<Visibility once={false} onBottomPassed={this.showFixedMenu} onBottomPassedReverse={this.hideFixedMenu} style={{}}>
					<Menu fixed="top" inverted size="large" style={headerStyle}>
						<Menu
							style={{
								background: "transparent",
								border: 0,
								boxShadow: "none",
								fontSize: isMobile() ? 9 : isTabletOrLess() ? 12 : 15,
							}}
						>
							{user.rights === "ADMIN" && (
								<Menu.Item as={Link} to="/admin/general" className="menuItemAdmin" active={pathname === "/admin/general"}>
									Général
								</Menu.Item>
							)}

							<Menu.Item as={Link} to="/admin/users" className="menuItemAdmin" active={pathname === "/admin/users"}>
								Utilisateurs
							</Menu.Item>

							{this.props.user.rights === "ADMIN" && (
								<>
									<Dropdown item text="Analyses">
										<Dropdown.Menu>
											<Dropdown.Item as={Link} to="/admin/analyses" className="menuItemAdmin" active={pathname === "/admin/analyses"}>
												Analyses
											</Dropdown.Item>
											<Dropdown.Item as={Link} to="/admin/analysesPacks" className="menuItemAdmin" active={pathname === "/admin/analysesPacks"}>
												Packs d'analyses
											</Dropdown.Item>
											<Dropdown.Item
												as={Link}
												to="/admin/analysesPacksPrescriber"
												className="menuItemAdmin"
												active={pathname === "/admin/analysesPacksPrescriber"}
											>
												Packs prescripteur
											</Dropdown.Item>
										</Dropdown.Menu>
									</Dropdown>

									<Dropdown item text="Questions">
										<Dropdown.Menu>
											<Dropdown.Item as={Link} to="/admin/questions" className="menuItemAdmin" active={pathname === "/admin/questions"}>
												Questions
											</Dropdown.Item>

											<Dropdown.Item
												as={Link}
												to="/admin/systematicQuestions"
												className="menuItemAdmin"
												active={pathname === "/admin/systematicQuestions"}
											>
												Questions Systématiques
											</Dropdown.Item>
											<Dropdown.Item as={Link} to="/admin/motivations" className="menuItemAdmin" active={pathname === "/admin/motivations"}>
												Motivations
											</Dropdown.Item>

											<Dropdown.Item as={Link} to="/admin/answers" className="menuItemAdmin" active={pathname === "/admin/answers"}>
												Réponses
											</Dropdown.Item>
										</Dropdown.Menu>
									</Dropdown>

									<Dropdown item text="Autres">
										<Dropdown.Menu>
											<Dropdown.Item as={Link} to="/admin/tubes" className="menuItemAdmin" active={pathname === "/admin/tubes"}>
												Tubes
											</Dropdown.Item>

											<Dropdown.Item as={Link} to="/admin/tubeReasons" className="menuItemAdmin" active={pathname === "/admin/tubeReasons"}>
												Motifs Tube
											</Dropdown.Item>
											<Dropdown.Item as={Link} to="/admin/cancelReasons" className="menuItemAdmin" active={pathname === "/admin/cancelReasons"}>
												Raisons annulation dossier télésecrétariat
											</Dropdown.Item>

											{/* <Dropdown.Item as={Link} to="/admin/partners" className="menuItemAdmin" active={pathname === "/admin/partners"}>
												Sociétés partenaires de prélèvements
											</Dropdown.Item> */}
											<Dropdown.Item as={Link} to="/admin/centers" className="menuItemAdmin" active={pathname === "/admin/centers"}>
												Centres
											</Dropdown.Item>

											<Dropdown.Item as={Link} to="/admin/box" className="menuItemAdmin" active={pathname === "/admin/box"}>
												Box
											</Dropdown.Item>

											<Dropdown.Item as={Link} to="/admin/insurances" className="menuItemAdmin" active={pathname === "/admin/insurances"}>
												Mutuelles
											</Dropdown.Item>

											<Dropdown.Item as={Link} to="/admin/specialRegimes" className="menuItemAdmin" active={pathname === "/admin/specialRegimes"}>
												Rég. Spé.
											</Dropdown.Item>

											<Dropdown.Item as={Link} to="/admin/specialties" className="menuItemAdmin" active={pathname === "/admin/specialties"}>
												Spécialités médecin
											</Dropdown.Item>

											<Dropdown.Item as={Link} to="/admin/companies" className="menuItemAdmin" active={pathname === "/admin/companies"}>
												Sociétés de facturation
											</Dropdown.Item>
											<Dropdown.Item as={Link} to="/admin/labParamGroups" className="menuItemAdmin" active={pathname === "/admin/labParamGroups"}>
												Grp Lab Param
											</Dropdown.Item>
											<Dropdown.Item as={Link} to="/admin/laboratories" className="menuItemAdmin" active={pathname === "/admin/laboratories"}>
												Labo
											</Dropdown.Item>
											<Dropdown.Item as={Link} to="/admin/emergencyReasons" className="menuItemAdmin" active={pathname === "/admin/emergencyReasons"}>
												Urgence
											</Dropdown.Item>
											<Dropdown.Item as={Link} to="/admin/contactComments" className="menuItemAdmin" active={pathname === "/admin/contactComments"}>
												Commentaire Contact
											</Dropdown.Item>
											<Dropdown.Item
												as={Link}
												to="/admin/consentRefusalReasons"
												className="menuItemAdmin"
												active={pathname === "/admin/consentRefusalReasons"}
											>
												Motif de refus de prise en charge
											</Dropdown.Item>
											<Dropdown.Item as={Link} to="/admin/sampleTypes" className="menuItemAdmin" active={pathname === "/admin/sampleTypes"}>
												Type de prélèvement
											</Dropdown.Item>
											<Dropdown.Item as={Link} to="/admin/documentTypes" className="menuItemAdmin" active={pathname === "/admin/documentTypes"}>
												Type de document
											</Dropdown.Item>
											<Dropdown.Item
												as={Link}
												to="/admin/validationPausedReasons"
												className="menuItemAdmin"
												active={pathname === "/admin/validationPausedReasons"}
											>
												Motifs pause validation
											</Dropdown.Item>
											{/* <Dropdown.Item
										as={Link}
										to='/admin/servipayTerminal'
										className='menuItemAdmin'
										active={pathname === '/admin/servipayTerminal'}
									>
										Terminaux Servipay
									</Dropdown.Item> */}
											<Dropdown.Item as={Link} to="/admin/translate" className="menuItemAdmin" active={pathname === "/admin/translate"}>
												Traductions
											</Dropdown.Item>
											<Dropdown.Item as={Link} to="/admin/externalServices" className="menuItemAdmin" active={pathname === "/admin/externalServices"}>
												Services externes
											</Dropdown.Item>
											<Dropdown.Item as={Link} to="/admin/scanner" className="menuItemAdmin" active={pathname === "/admin/scanner"}>
												Scanners
											</Dropdown.Item>
										</Dropdown.Menu>
									</Dropdown>
								</>
							)}
							<Menu.Item as={Link} to="/admin/logs" className="menuItemAdmin" active={pathname === "/admin/logs"}>
								Logs
							</Menu.Item>
							<Menu.Item as={Link} to="/admin/dashboard" className="menuItemAdmin" active={pathname === "/admin/dashboard"}>
								Dashboard
							</Menu.Item>
							<Menu.Item as={Link} to="/admin/folders/opened" className="menuItemAdmin" active={pathname === "/admin/folders/opened"}>
								Dossiers ouverts
							</Menu.Item>
							{generalParameters.data.helpNurse && (
								<Menu.Item as={Link} to="/admin/helpNurses" className="menuItemAdmin" active={pathname === "/admin/helpNurses"}>
									Télésecrétariat
								</Menu.Item>
							)}
							{generalParameters.data.live && (
								<Menu.Item as={Link} to="/admin/live" className="menuItemAdmin" active={pathname === "/admin/live"}>
									Appel Live
								</Menu.Item>
							)}

							<Menu.Item as={Link} to="/admin/preregister" className="menuItemAdmin" active={pathname === "/admin/preregister"}>
								Pré-inscriptions
							</Menu.Item>
							<Menu.Item as={Link} to="/admin/facturation" className="menuItemAdmin" active={pathname === "/admin/facturation"}>
								Facturation
							</Menu.Item>
							<Menu.Item as={Link} to="/admin/campaigns" className="menuItemAdmin" active={pathname === "/admin/campaigns"}>
								Campagnes
							</Menu.Item>
							<Menu.Item as={Link} to="/admin/mobility" className="menuItemAdmin" active={pathname === "/admin/mobility"}>
								Mobilité
							</Menu.Item>

							{/* 	<Menu.Item
								as={Link}
								to='/admin/payment'
								className='menuItemAdmin'
								active={pathname === '/admin/payment'}
							>
								Paiement
							</Menu.Item> 
							<Menu.Item
								as={Link}
								to='/admin/notifications'
								className='menuItemAdmin'
								active={pathname === '/admin/notifications'}
							>
								Notifications
							</Menu.Item>  */}
						</Menu>

						<Menu.Menu position="right">
							<Popup
								content="Quitter"
								trigger={
									<Menu.Item as={Link} to="/home/lab">
										<Icon name="log out" style={{ margin: 0 }} />
									</Menu.Item>
								}
							/>
						</Menu.Menu>
					</Menu>
				</Visibility>

				{children}
			</div>
		);
	}
}

export const AdminResponsiveContainer = ({ children, logout, pathname, generalParameters, user }) => (
	<DesktopContainer user={user} logout={logout} pathname={pathname} generalParameters={generalParameters}>
		{children}
	</DesktopContainer>
);

AdminResponsiveContainer.propTypes = {
	children: PropTypes.node,
	logout: PropTypes.func,
	generalParameters: PropTypes.object,
	user: PropTypes.object,
};
